import PropTypes from "prop-types";
import Select from "../Inputs/Select";

function SelectStep({
  title,
  description,
  options,
  statekey,
}: {
  title: string;
  description: string;
  options: string[];
  statekey: string;
}) {
  return (
    <div className="Step SelectStep">
      <h2>{title}</h2>
      <p>{description}</p>
      <Select options={options} statekey={statekey} />
    </div>
  );
}

export default SelectStep;

SelectStep.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  options: PropTypes.array,
  statekey: PropTypes.string,
};
